export const initialGnfr = "COMBINED";

export const m2tokm2 = 1e-6;

export const utfBom = "\ufeff";
